<template>
  <div class="sign-in-container c-app flex-row align-items-center">
    <CContainer>
      <CRow class="justify-content-center">
        <CCol md="6">
          <CCardGroup>
            <CCard class="p-4">
              <CCardBody>
                <h3 class="text-center text-underline mb-4">高齢者入居促進サービス　みまもりＡｉｒ</h3>
                <amplify-authenticator :authConfig="authConfig"></amplify-authenticator>
              </CCardBody>
            </CCard>
          </CCardGroup>
        </CCol>
      </CRow>
    </CContainer>
  </div>
</template>
<script>
import { AmplifyEventBus } from 'aws-amplify-vue'

export default {
  name: 'SignIn',

  data () {
    return {
      authConfig: {
        signInConfig: {
          isSignUpDisplayed: false
        }
      }
    }
  }
}
</script>